//Модуль перехвата нажатия клавиши
//Используем всегда когда надо перехватить нажатие клавиши что бы повторно не навешивать addEventListener который надо будет как-то убивать и заново добавлять...
import { onkeydown } from '@/main.js';
export default window.addEventListener("keydown", event => {
	var key = event.key;
    if(key === 'ƒ' || key === '÷') {
        onkeydown.emit('search');
    }
})